import { gql } from '@apollo/client'
import {
  SubmitBatch,
  SubmitBatchVariables,
  SubmitBatch_submitBatch
} from 'src/smart/mutations/types/SubmitBatch'
import { SmartMutation } from 'src/smart/SmartMutation'

export const SM_SUBMIT_BATCH: SmartMutation<
  SubmitBatchVariables,
  SubmitBatch,
  SubmitBatch_submitBatch
> = {
  mutation: gql`
    mutation SubmitBatch($batchId: String!, $dismissRemainingRecords: Boolean) {
      submitBatch(batchId: $batchId, dismissRemainingRecords: $dismissRemainingRecords) {
        batchId
        status
      }
    }
  `,
  extract: ({ submitBatch }) => submitBatch
}
